import { call, put, takeEvery } from "redux-saga/effects";
import { INIT_DATA, initializeData, loadFeatureFlag, loadFeatureFlagFailed, loadFeatureFlagSuccess } from "./action";
import { getInitialPartnerDetails } from "../../reducers/reducer-partner-details";
import { getFeatureFlagSetDRW, GetFeatureFlagSetParams, GetFeatureFlagSetResponse, getOmniStreamlinedDRW, searchOngoingRescue } from "../../api";
import { refreshReducersToInitial, requestPartnerDetails } from "../../action";
import { datadogRum } from "@datadog/browser-rum";
import { getPersistor } from "../../getStore";
import { logExperimentGroup } from "./utils";

const { route, displayCode: partnerCode } = getInitialPartnerDetails();
const trackerPartnerCode = window.location.pathname.split("/")[3];

const DEFAULT_FEATURE_FLAGS: GetFeatureFlagSetResponse = {
  disableGoogleNearbyRecommendations: false,
  enableChatBot: false,
  enableDRWTimeZone: false,
  enableGHRPromotion: false,
  enableLanguageOption: false,
  enableListViewForDestinationLocations: false,
  enablePartnerDetailsMethod: "getPartnerDetailsApi",
  enablePepWalletCoupon: false,
  enablePredictiveETAInDRW: false,
  enableRescueTrackerChat: false,
  enableRescueTrackerStatusMethod: "getVerifiedRescueTrackerStatus",
  enableUrlShortener: false,
  omniStreamlined: "",
  pepPromotionFlag: "",
};

function* onInit() {
  yield put(initializeData());
  const values = new URLSearchParams(window.location.search);
  const aniValue = values.get("ANI");
  let sessionRoute;
  if (!!sessionStorage.getItem("route")) {
    sessionRoute = sessionStorage.getItem("route");
  }

  yield put(loadFeatureFlag({ route, partnerCode }));
  let response;
  let currentPartnerCode = partnerCode;
  try {
    if (sessionRoute === "member" && route === "wd" && partnerCode === "l") {
      currentPartnerCode = trackerPartnerCode;
    } else if (
      (route === "appointment-confirmation" && partnerCode === undefined)
    ) {
      yield put(loadFeatureFlagSuccess(DEFAULT_FEATURE_FLAGS)); // Default to empty value for wd
      return;
    } else if (route === "wd" && partnerCode === "l" && aniValue) {
      currentPartnerCode = trackerPartnerCode;
    }

    const key = sessionStorage.getItem("uuid") || (() => {
      const newId = crypto.randomUUID();
      sessionStorage.setItem("uuid", newId);
      return newId;
    })();

    let payload: GetFeatureFlagSetParams = {
      kind: "user",
      key,
      partnerCode: currentPartnerCode,
      route,
    };

    response = yield call(getFeatureFlagSetDRW, payload);

    if (!response || !response.data) {
      response = yield call(getOmniStreamlinedDRW, currentPartnerCode);
    }

    if (response && response.data) {
      yield put(loadFeatureFlagSuccess(response.data));
      const key2 = sessionStorage.getItem("uuid");
      if (key2 !== "omniStreamlined") {
        logExperimentGroup(response.data.enableChatBot);
      }
    } else {
      yield put(loadFeatureFlagSuccess(DEFAULT_FEATURE_FLAGS));
    }

    const commonBenefits = JSON.parse(localStorage.getItem("commonBenefits"));
    const partner = currentPartnerCode || commonBenefits?.partnerCode;
    if (partner && partner !== "l" && partner !== "f") {
      yield put(requestPartnerDetails(partner));
    }
  } catch (error) {
    datadogRum.addError(`Feature flag service returned an error when loading feature flags.`, {
      error: error,
      partnerCode: currentPartnerCode,
    });
    yield put(loadFeatureFlagFailed(error));
  }
}

function* initDataSaga() {
  try {
    const submitRequest = JSON.parse(localStorage.getItem("submitRequest"));
    if (submitRequest?.success) {
      const appointmentNumber = localStorage.getItem("benefitSession");
      const hasOpenApiId = appointmentNumber && appointmentNumber.includes("-");
      const commonBenefits = JSON.parse(localStorage.getItem("commonBenefits"));
      const partner = commonBenefits?.partnerCode || partnerCode;

      if (partner && appointmentNumber && !hasOpenApiId) {
        const hasOngoingRescue = yield call(searchOngoingRescue, partner, appointmentNumber);
        if (!hasOngoingRescue) {
          let tollFreeNumber = localStorage.getItem("tollFreeNumber");
          getPersistor().purge();
          localStorage.clear();
          yield put(refreshReducersToInitial());
          localStorage.setItem("tollFreeNumber", tollFreeNumber);

          datadogRum.addAction("Outdated Rescue Cached - storage cleared");
        }
      }
    }
  } catch (e) {
    datadogRum.addError(
      new Error(`Rescue status view service returned an error when checking for ongoing rescue. - ${e}`)
    );
  }
}

export function* watchInitSaga() {
  yield takeEvery("@@App/INIT", onInit);
  yield takeEvery(INIT_DATA, initDataSaga);
}
